import { Routes } from 'app/services/routeService/routeService'
import IntegrationsBeewo from './IntegrationsBeewo'

export const IntegrationBeewoConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.socialMediaIntegrationsBeewo(),
      component: IntegrationsBeewo,
      accesses: [],
    },
  ],
}
